import { addOneBarcode, addTwoBarcode } from "../../../helpers/addBarcode";
import { uploadFileAsync } from "../../../helpers/UploadFile";
import { IAppendDocs } from "../../../interfaces/Correspondence";
import { setActiveCorrespondenceDocManagment } from "../../../redux/actions/documentManagmentActions";
import { setActiveFuidFileModule } from "../../../redux/actions/fileModuleActions";
import { setActiveFuid } from "../../../redux/actions/fuidActions";
import {
  setSuccessMsg,
  uiCloseModalAction,
  uiOpenSuccessAlert,
} from "../../../redux/actions/uiActions";
import { AppState } from "../../../redux/reducers/rootReducer";
import {
  IAppendDocsSend,
  IDocsExpedientsSend,
  IDocumentsFuid,
  IFiles,
} from "../../../redux/types/types";
import { addAttachedDocumentCorrespondenceDb } from "../../../services/firebase/correspondence";
import { addAttachedDocumentExpedientDb } from "../../../services/firebase/fuid";
import { isPasswordProtected } from "../FileValidation";

export const saveFilesFirebase = async (
  files: any[],
  correspondenceId1: string,
  correspondenceId2: string,
  userId: string,
  username: string,
  entityId: string,
  applyBarcode: boolean = true
) => {
  let digitalSupportParse: IFiles[] = [];
  if (files.length > 0) {
    for (const document of files) {
      if (document.file) {
        if (document.file.type === "application/pdf" && applyBarcode) {
          if (await isPasswordProtected(document.file)) {
            if (correspondenceId2 === "") {
              document.file = await addOneBarcode(
                document.file,
                correspondenceId1
              );
            } else {
              document.file = await addTwoBarcode(
                document.file,
                correspondenceId1,
                correspondenceId2
              );
            }
          }
        }
        const newFileObj = await uploadFileFirebase(
          document.file,
          entityId,
          document.fileName,
          userId,
          username
        );

        digitalSupportParse.push(newFileObj);
      }
      // document.url !== "#" && digitalSupportParse.push(document);
    }
  }
  // console.log("digitalSupportParse", digitalSupportParse);
  return digitalSupportParse.length > 0 ? digitalSupportParse : files;
};

const uploadFileFirebase = async (
  file: any,
  entityId: string,
  fileName: string,
  userId: string,
  username: string
) => {
  const url = await uploadFileAsync(
    file,
    `/correspondence/${entityId}/${fileName}`
  );
  const newFileObj: IFiles = {
    fileName: fileName,
    url,
    owner: {
      id: userId,
      username: username,
    },
  };

  return newFileObj;
};

// FUNCION PARA AGREGAR DOCUMENTO ADJUNTO
export const addAttachedDocumentCorrespondence = (
  objsAppendDocs: IAppendDocsSend | IDocsExpedientsSend,
  file: File,
  expedient?: boolean,
  fromModule?: boolean,
  isExpedient?: boolean,
  idExpedientCorrespondence?: string
) => {
  return async (dispatch: any, getState: Function) => {
    const { activeExpedient: expedientFuid } = (getState() as AppState).fuid;
    const { activeExpedientFileModule: expedientFileModule } = (
      getState() as AppState
    ).fileModule;
    const { user } = (getState() as AppState).auth;
    const { activeCorrespondence } = (getState() as AppState).documentManagment;

    if (
      !user ||
      !user.idEntity ||
      !(activeCorrespondence || expedientFuid || expedientFileModule)
    ) {
      throw new Error("falta de información del usuario uploadFileTiFireBase");
    }

    for (let i = 0; i < objsAppendDocs.appendDocs.length; i++) {
      if (objsAppendDocs.appendDocs[i].url === "#") {
        let addedFile = file;
        const route = !!expedient
          ? `expedients/${user.idEntity}/${
              (objsAppendDocs as IDocsExpedientsSend).appendDocs[i].fileName
            }`
          : `correspondence/${user.idEntity}/${
              (objsAppendDocs as IAppendDocsSend).appendDocs[i].filename
            }`;

        if (addedFile.type === "application/pdf" && activeCorrespondence?.id) {
          addedFile = await addOneBarcode(addedFile, activeCorrespondence.id);
        }

        const urlFile = await uploadFileAsync(addedFile, route);
        objsAppendDocs.appendDocs[i].url = urlFile;
      }
    }

    const idDoc = !!expedient
      ? (objsAppendDocs as IDocsExpedientsSend).idExpedient
      : (objsAppendDocs as IAppendDocsSend).idCorrespondence;
    const module = fromModule ? "FileModule" : "Correspondence";
    // AGREGAR DOCUMENTOS SI HAY O NO EXPEDIENTE ASIGANDO A LA CORRESPONDENCIA
    if (isExpedient && idExpedientCorrespondence) {
      const { ok } = await addAttachedDocumentExpedientDb(
        module,
        idExpedientCorrespondence,
        objsAppendDocs.appendDocs as IDocumentsFuid[],
        user.idEntity
      );
      if (ok) {
        expedientFuid!.documents = (
          objsAppendDocs as IDocsExpedientsSend
        ).appendDocs;
        dispatch(setActiveFuid(expedientFuid));
      }
    }
    const { ok } = !!expedient
      ? await addAttachedDocumentExpedientDb(
          module,
          idDoc!,
          objsAppendDocs.appendDocs as IDocumentsFuid[],
          user.idEntity
        )
      : await addAttachedDocumentCorrespondenceDb(
          idDoc!,
          objsAppendDocs.appendDocs as IAppendDocs[],
          user.idEntity
        );
    if (ok) {
      if (!!expedient) {
        fromModule
          ? (expedientFileModule!.documents = (
              objsAppendDocs as IDocsExpedientsSend
            ).appendDocs)
          : (expedientFuid!.documents = (
              objsAppendDocs as IDocsExpedientsSend
            ).appendDocs);
        fromModule
          ? dispatch(setActiveFuidFileModule(expedientFileModule))
          : dispatch(setActiveFuid(expedientFuid));
      } else {
        activeCorrespondence &&
          (activeCorrespondence.appendDocs = (
            objsAppendDocs as IAppendDocsSend
          ).appendDocs);
        activeCorrespondence &&
          dispatch(setActiveCorrespondenceDocManagment(activeCorrespondence));
      }
      dispatch(uiCloseModalAction());
      dispatch(setSuccessMsg("AttachedDocument"));
      dispatch(uiOpenSuccessAlert());
    }
  };
};
